import layout from '@/layouts/layout.vue'

export default [
  {
    path: '/',
    component: layout,
    children: [{
      path: '/',
      name: 'home',
      component: resolve => require.ensure([], () => resolve(require('@/views/home/Home.vue')), 'home'),
      meta: { title: '首页', icon: '' }
    }]
  }
]
